<template>
  <div class="father">
    <nav>
      <div class="widthSet cursorPointer">
        <!-- 1200宽度↓ -->
        <!-- 第一行↓ -->
        <div class="info">
          <div class="leftInfo" @click="toLinkHome">
            <!-- ↓左盒子-->
            <div class="logo"><img src="@/assets/css/img/topTitle.png" alt=""></div>
            <div class="infotext">
              <p>沈阳市跳绳协会</p>
              <p>Shenyang Jump Rope Association</p>
            </div>
          </div><!-- ↑左盒子-->
          <div class="rightInfo" :class="{ 'is-login': logintoken }">
            <!-- ↓右盒子-->
            <!-- 未登录状态↓ -->
            <div class="nonelogin" v-if="logintoken === false">
              <!-- 资料下载入口暂时下线 -->
              <!-- <button class="dl-entry" @click="downloadVisible = true"><i class="el-icon-download"></i>资料下载</button> -->
              <button @click="openLogin"><i class="el-icon-user-solid"></i>登录</button>
              <!-- <button  @click="dialoglogonVisible = true"><i class="el-icon-user"></i>注册</button> -->
              <button @click="openRegister"><i class="el-icon-user"></i>注册</button>
            </div>
            <!-- 未登录状态↑ -->
            <!-- 登录状态↓ -->
            <!-- 上方信息静态信息↓ -->
            <div class="loginok" v-else>
              <!-- 上方信息静态信息↓ -->
              <div class="rightAlign">
                <div v-if="accountInfotype === 1" class="rightAlign-item">
                  <span>欢迎你！{{personInfo.realName || "游客用户"}} </span>
                  <!-- 会员标识：金黄V标=会员 / 灰V标=非会员（member_flag 报名开通） -->
                  <span class="vip-badge" :class="personInfo.memberFlag === 1 ? 'is-vip' : 'not-vip'">
                    <i class="vip-badge-v">V</i>{{ personInfo.memberFlag === 1 ? '会员' : '非会员' }}
                  </span>

                </div>
                <div v-else class="rightAlign-item">
                  <span>欢迎你！{{organInfo.orgName || "游客机构"}}</span>
                  <!-- 会员标识：金黄V标=会员 / 灰V标=非会员（member_flag 报名开通） -->
                  <span class="vip-badge" :class="organInfo.memberFlag === 1 ? 'is-vip' : 'not-vip'">
                    <i class="vip-badge-v">V</i>{{ organInfo.memberFlag === 1 ? '会员' : '非会员' }}
                  </span>
                  <!-- &nbsp;<el-tooltip placement="right">
                    <div slot="content">已认证机构</div>
                    <span class="authlogo"><img v-if="organInfostate === 1"
                        src="@/assets/css/member/auth.png"></img></span>
                  </el-tooltip> -->
                </div>
                <div v-if="accountInfotype === 1&&personInfo.isVip === 1" style="margin-bottom: 1rem;text-align: left;">
                  <span style="margin-right: 1rem;">会员码：{{personInfo.userCode}}</span>
                  <span>积分：{{personInfo.signScore}}</span>
                </div>
                <div v-if="accountInfotype === 2&&organInfo.isVip === 1" style="margin-bottom: 1rem;text-align: left;">
                  <span style="margin-right: 1rem;">会员码：{{organInfo.orgCode}}</span>
                  <span>积分：{{organInfo.signScore}}</span>
                </div>
                <!-- <p  v-else>欢迎你！问问我游客机构</p> -->
              </div>
              <!-- 上方信息静态信息↑ -->
              <!-- 下方操作按钮↓ -->
              <div class="clicki">
                <div>
                  <!-- 资料下载入口暂时下线 -->
                  <!-- <button class="dl-entry" @click="downloadVisible = true"><i class="el-icon-download"></i>资料下载</button> -->
                  <!-- 签到/会员功能入口暂时下线 -->
                  <!-- <button @click="toSign" v-if="isSignIn ==0">签到</button>
                  <button @click="toSign" v-if="isSignIn ==1"
                    style="background-color:#009a33;border: #009a33;">已签到</button>
                  <button @click="toVip">会员功能</button> -->
                  <button @click="toinfo">个人中心</button>
                  <button @click="toScoreQuery" v-if="hasPerm('viewScore')">成绩查询</button>
                  <button @click="loginout">退出登录</button>
                </div>
              </div>
            </div>
            <!-- 登录状态↑ -->

          </div><!-- ↑右盒子-->

          <!-- 移动端 汉堡菜单按钮（放在注册按钮右侧，作为 .info 的同排 flex 项） -->
          <div class="mobile-menu-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
            <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-s-unfold'"></i>
          </div>
        </div>
        <!-- 第一行↑ -->

        <!-- 移动端 折叠导航 -->
        <transition name="el-fade-in">
          <div class="mobile-nav" v-show="mobileMenuOpen">
            <div
              class="mobile-nav-item"
              :class="{ active: activeIndexActive === item.key }"
              v-for="item in mobileNavItems"
              :key="item.key"
              @click="handleSelect(item.key)"
            >{{ item.label }}</div>
          </div>
        </transition>

        <!-- 第二行↓ -->
        <!-- class="el-menu-demo" menu-trigger="click" -->
        <div class="tabSelect">
          <el-menu :default-active="activeIndexActive" mode="horizontal" @select="handleSelect"
            background-color="#1E40AF" text-color="#fff" active-text-color="#93C5FD">

            <el-menu-item index="1">首页</el-menu-item>
            <!-- 三个专区入口（登录前后均展示） -->
            <el-menu-item index="11">赛事专区</el-menu-item>
            <el-menu-item index="10">服务专区</el-menu-item>
            <el-menu-item index="12">体智能专区</el-menu-item>
            <!-- 协会公告 + 新闻专区 已整合为统一"新闻公告"导航入口 2026-08-31 -->
            <el-menu-item index="2">新闻公告</el-menu-item>
            <!-- 活动中心导航入口已停用：2026-08-31 整体迁移整合至"体智能专区"(index 12)的"活动中心"标签页 -->
            <!-- <el-menu-item index="8">活动中心</el-menu-item> -->
            <!-- 组织机构/会员单位/关于协会 入口已停用（2026-09-02 前端隐藏，路由与页面保留可直连） -->
            <!-- <el-menu-item index="7">组织机构</el-menu-item> -->
            <!-- <el-menu-item index="5">会员单位</el-menu-item> -->
            <!-- <el-menu-item index="5">
              <template slot="title">会员单位</template>
              <el-menu-item index="5-1">会员机构</el-menu-item>
              <el-menu-item index="5-2">会员学校</el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="5-4">
                <template slot="title">选项4</template>
                <el-menu-item index="5-4-1">选项1</el-menu-item>
              </el-submenu> -->
            <!-- <el-menu-item index="6">关于协会</el-menu-item> -->
          </el-menu>
        </div>
        <!-- 第二行↑ -->


      </div> <!-- 1200宽度↑ -->

    </nav>

    <!-- 登录弹出层 :close-on-click-modal="false" 设置点击遮罩不关闭弹窗-->
    <el-dialog :visible.sync="dialogloginVisible" v-if="dialogloginVisible" :close-on-click-modal="false" width="760px" custom-class="identity-dialog">
      <login @closelogin="closelogin"></login>
    </el-dialog>
    <!-- 注册弹出层：第一步选注册类型（个人/组织），第二步选身份 -->
    <el-dialog :visible.sync="dialogregisterVisible" v-if="dialogregisterVisible" :close-on-click-modal="false" width="760px" custom-class="identity-dialog">
      <!-- 第一步：注册类型 -->
      <div v-if="registerStep === 'type'" class="register-type-select">
        <div class="rts-title">请选择注册类型</div>
        <div class="rts-subtitle">选择类型后进入对应注册流程</div>
        <div class="rts-cards">
          <div class="rts-card personal" @click="registerStep = 'role'">
            <div class="rts-icon"><i class="el-icon-user"></i></div>
            <div class="rts-name">个人注册</div>
            <div class="rts-desc">裁判员 / 培训员 / 学员</div>
          </div>
          <div class="rts-card organ" @click="registerStep = 'orgType'">
            <div class="rts-icon"><i class="el-icon-office-building"></i></div>
            <div class="rts-name">组织注册</div>
            <div class="rts-desc">学校 / 机构 / 协会</div>
          </div>
        </div>
      </div>
      <!-- 第二步：组织类型选择（学校 / 俱乐部 / 协会单位） -->
      <div v-else-if="registerStep === 'orgType'" class="register-type-select">
        <div class="rts-title">请选择组织类型</div>
        <div class="rts-subtitle">选择组织类型后进入对应注册页</div>
        <div class="rts-cards">
          <div class="rts-card org-school" @click="goOrganRegister('school')">
            <div class="rts-icon"><i class="el-icon-school"></i></div>
            <div class="rts-name">学校注册</div>
            <div class="rts-desc">面向学校及校园单位</div>
          </div>
          <div class="rts-card org-club" @click="goOrganRegister('club')">
            <div class="rts-icon"><i class="el-icon-s-cooperation"></i></div>
            <div class="rts-name">机构注册</div>
            <div class="rts-desc">面向俱乐部及培训机构</div>
          </div>
          <div class="rts-card org-assoc" @click="goOrganRegister('association')">
            <div class="rts-icon"><i class="el-icon-s-flag"></i></div>
            <div class="rts-name">协会注册</div>
            <div class="rts-desc">面向协会及社会团体</div>
          </div>
        </div>
        <div class="rts-back" @click="registerStep = 'type'"><i class="el-icon-back"></i> 返回上一步</div>
      </div>
      <!-- 第三步：身份选择（个人注册） -->
      <identity-select v-else :show-back="true" @back="registerStep = 'type'" @select="onRegisterIdentity" title="请选择注册身份" subtitle="选择身份后进入对应注册页"></identity-select>
    </el-dialog>
    <!-- 待认证弹出层 -->
    <el-dialog :visible.sync="dialogauthVisible" v-if="dialogauthVisible" :close-on-click-modal="false">
      <!-- 个人认证弹出层 -->
      <auth v-if="accountInfotype == '1'" @closeauth="closeauth"></auth>
      <!-- 机构认证弹出层 -->
      <organauth v-else @closeorganauth="closeorganauth"></organauth>
    </el-dialog>
    <!-- 资料下载弹窗 -->
    <el-dialog title="资料下载" :visible.sync="downloadVisible" width="520px" :close-on-click-modal="false">
      <ul class="download-dialog-list">
        <li
          class="download-item"
          v-for="r in downloadResources"
          :key="r.name"
          @click="downloadResource(r)"
        >
          <i class="el-icon-document"></i>
          <span class="download-item-name">{{ r.name }}</span>
          <i class="el-icon-download download-item-icon"></i>
        </li>
      </ul>
    </el-dialog>
    <!-- Sign-in Modal -->
    <el-dialog :visible.sync="dialogSignInVisible" title="签到" :close-on-click-modal="false" class="calendar-dialog"
      width="45%" top="2vh">
      <div class="sign-in-calendar">
        <div class="calendar-header">
          <h1>{{ formattedDate }}</h1>
          <div class="month-display">
            <select v-model="selectedMonth" class="date-select" @change="getCanderDetail">
              <option v-for="month in monthOptions" :key="month" :value="month">{{ month + 1 }}月</option>
            </select>
          </div>
        </div>
        <div class="calendar-grid">
          <div class="weekday-header" v-for="day in weekDays" :key="day">{{ day }}</div>
          <div v-for="(day, index) in calendarDays" :key="index" :class="[
          'calendar-day',
          { 'current-month': day.currentMonth },

          { 'today': isToday(day.date) && !day.signed },
          { 'today-signed': isToday(day.date) && day.signed }
        ]" @click="signIn(day)">
            <span class="day-number"
              :class="{ 'today-day-number-nosign': isToday(day.date) && !day.signed}">{{ day.dayNumber }}</span>
            <div v-if="day.signed" class="circle-out">
              <span class="circle">√</span>
              <span class="points">+{{ day.points }}</span>
            </div>
            <div v-if="isToday(day.date) && !day.signed">
              点击签到
            </div>
            <!-- <span v-if="day.signed" class="points">+{{ day.points }}</span> -->
          </div>
        </div>
        <!-- <div class="sign-in-button-container">
          <button class="sign-in-button" @click="signInToday" :class="{ 'signed': isTodaySigned }">
            {{ isTodaySigned ? '今日已签到' : '立即签到' }}
          </button>
        </div> -->
      </div>
      <span slot="footer" style="display: flex; justify-content: center;margin-top: -3rem;">
        <el-button @click="dialogSignInVisible = false"
          style="width: 10rem; color: #fff;background-color: #0099ff;font-size: 1rem;font-weight: 600; height: 3rem;">关
          闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import request from '../utils/request'
  import '../assets/css/base.css'
  import { DOWNLOAD_RESOURCES } from '../utils/downloadResources'
  import login from '@/components/Loginstart'
  import identityselect from '@/components/IdentitySelect'
  import auth from '@/components/authstart'
  import organauth from '@/components/organauthstart'
  import {
    mapGetters
  } from 'vuex'

  export default {
    components: {
      login,
      IdentitySelect: identityselect,
      auth,
      organauth
    },
    data() {
      return {
        // isSignIn: '',
        activeIndexActive: "1", //tab选项卡 默认激活序号
        //是否已登录判断  true已登录 false未登录
        // login:this.logintoken || JSON.parse(sessionStorage.getItem('logintoken')) || false, 
        //使用vuex及本地存储赋值 保持响应及页面刷新不丢失  //若(vuex中state 或 本地存储)有值则为登录 若无值则为false（未登录）
        ispersonsign: false, //是否已签到

        dialogloginVisible: false, //登录弹出层
        dialogregisterVisible: false, //注册身份选择弹出层
        registerStep: 'type', // 注册流程步骤：type=注册类型选择 role=身份选择
        mobileMenuOpen: false, //移动端导航折叠
        dialogauthVisible: false, //待认证弹出层
        dialogSignInVisible: false,
        downloadResources: DOWNLOAD_RESOURCES, //资料下载列表
        downloadVisible: false, //资料下载弹窗开关
        // 星期几的显示文本
        weekDays: ['一', '二', '三', '四', '五', '六', '日'],
        // 当前日期对象
        currentDate: new Date(),
        // 选中的月份
        selectedMonth: new Date().getMonth(),
        // 已签到日期数组
        signInDates: [],
        // 连续签到天数
        consecutiveDays: 0,
        // 是否显示消息
        showMessage: false,
        // 消息内容
        message: ''
      }
    },
    created() {
      // console.log(this.organInfo,77777)
      // if (this.personInfo && this.personInfo.isSignIn) {
      //   this.isSignIn = this.personInfo.isSignIn
      // }
      // if (this.organInfo && this.organInfo.isSignIn) {
      //   this.isSignIn = this.organInfo.isSignIn
      // }
      this.activeIndexActive = this.tabIndexActive
      if (this.personInfoid) {
        this.getpersoninfoall()
      }
      console.log(this.organInfoid, 8888)
      if (this.organInfoid) {
        this.getorganinfo()
      }

    },
    beforeDestroy() {
      this.$root.$off('open-login')
    },
    mounted() {
      // 监听“返回登录”请求（注册页等路由页面通过 $root 触发）
      this.$root.$on('open-login', () => {
        this.dialogloginVisible = true
      })
      // // 组件挂载时根据当前路由设置 activeIndexActive
      // const routeToIndexMap = {
      //   'home': '1',
      //   'Notice': '2',
      //   'move': '3',
      //   'activity': '8',
      //   'news': '4',
      //   'organ': '5', // 假设 'organ' 对应于 '5'
      //   'school': '5-2', // 假设 'school' 对应于 '5-2'
      //   'about': '6',
      //   'institution': '7'
      // };
      // const index = routeToIndexMap[this.$route.name];
      // console.log(this.$route.name,'index')
      // if (index) {
      //   this.$store.commit("updatetabIndexActive", index);
      //   // Vuex 状态变化会自动触发 watcher 更新 activeIndexActive
      // }

    },
    computed: {
      // vuex中开放的数据(均无法取到，因为 header文件 在未登录时就已经初始化渲染完成了  登录后)
      ...mapGetters([
        "personInfo",
        "organInfo",
        "logintoken", //token
        "personInfostate", //个人是否已认证
        "organInfostate", //机构是否已认证
        "accountInfotype", //登录类型为机构还是个人
        "accountRole", //账号角色 3裁判员 5培训员 6学员
        "accountPermissions", //账号权限数组
        "tabIndexActive", //index
        "vuexAboutData",
        "personInfoid",
        "organInfoid",
        "accountInfo"
      ]),
      // 移动端导航菜单项
      mobileNavItems() {
        return [
          { key: '1', label: '首页' },
          { key: '11', label: '赛事专区' },
          { key: '10', label: '服务专区' },
          { key: '12', label: '体智能专区' },
          // 协会公告 + 新闻专区 已整合为统一"新闻公告"导航入口 2026-08-31
          { key: '2', label: '新闻公告' },
          // 活动中心入口已停用：整体迁移至"体智能专区"的"活动中心"标签页
          // { key: '8', label: '活动中心' },
          // 组织机构/会员单位/关于协会 入口已停用（2026-09-02 前端隐藏）
          // { key: '7', label: '组织机构' },
          // { key: '5', label: '会员单位' },
          // { key: '6', label: '关于协会' }
        ]
      },
      isSignIn(){
        if(this.personInfoid) {
          return this.personInfo.isSignIn
        }
        if (this.organInfoid) {
          return this.organInfo.isSignIn
      }
      },
      formattedDate() {
        return `${this.currentYear} 年 ${this.selectedMonth + 1} 月`;
      },
      // 获取当前年份
      currentYear() {
        return this.currentDate.getFullYear()
      },
      // 获取当前月份（0-11）
      currentMonth() {
        return this.currentDate.getMonth()
      },
      // 计算日历网格中显示的所有日期
      calendarDays() {
        const days = []
        const firstDay = new Date(this.currentYear, this.currentMonth, 1)
        const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0)

        // 填充上个月的日期
        const firstDayWeekday = firstDay.getDay() || 7
        for (let i = 1; i < firstDayWeekday; i++) {
          const date = new Date(this.currentYear, this.currentMonth, 1 - i)
          days.unshift({
            date,
            dayNumber: date.getDate(),
            currentMonth: false,
            signed: this.isDateSigned(date),
            points: this.getSignInPoints(date)
          })
        }

        // 填充当前月的日期
        for (let i = 1; i <= lastDay.getDate(); i++) {
          const date = new Date(this.currentYear, this.currentMonth, i)
          days.push({
            date,
            dayNumber: i,
            currentMonth: true,
            signed: this.isDateSigned(date),
            points: this.getSignInPoints(date)
          })
        }

        // 填充下个月的日期
        const remainingDays = 42 - days.length
        for (let i = 1; i <= remainingDays; i++) {
          const date = new Date(this.currentYear, this.currentMonth + 1, i)
          days.push({
            date,
            dayNumber: i,
            currentMonth: false,
            signed: this.isDateSigned(date),
            points: this.getSignInPoints(date)
          })
        }

        return days
      },
      // 判断今天是否已签到
      isTodaySigned() {
        const today = new Date()
        return this.isDateSigned(today)
      },
      // 月份选项
      monthOptions() {
        return Array.from({
          length: 12
        }, (_, i) => i);
      }
    },
    watch: {
      selectedMonth(newMonth) {
        // 更新currentDate为选中月份的日期
        this.currentDate = new Date(this.currentDate.getFullYear(), newMonth, 1);
      },
      // activeIndexActive(newValue) {
      //   console.log(newValue,'newValue')
      //   this.$store.commit("updatetabIndexActive",newValue)
      // },
      // 监听 Vuex 中的 tabIndexActive 变化
      '$store.state.tabIndexActive'(newValue) {
        this.activeIndexActive = newValue;
      },
      // 监听路由变化
      '$route'(to, from) {
        const routeToIndexMap = {
          'home': '1',
          'newsNotice': '2', // 新闻公告统一入口（协会公告+新闻专区）
          'move': '3',
          // 'activity': '8', // 活动中心已迁移至体智能专区(12)
          'activityDetails': '12', // 活动详情页随迁移归入体智能专区
          'news': '2', // 新闻页已整合进"新闻公告"(index 2)
          'organ': '5', // 这里假设 'organ' 对应于 '5', 如果有更细分的路由，可能需要进一步处理
          'school': '5-2', // 假设 'school' 对应于 '5-2'
          'about': '6',
          'institution': '7',
          'serviceZone': '10',
          'partnerDetail': '10',
          'events': '11',
          'services': '10',
          'fitness': '12'
        };
        const index = routeToIndexMap[to.name];
        if (index) {
          this.$store.commit("updatetabIndexActive", index);
          // 由于 Vuex 状态变化会自动触发上面的 watcher，这里不需要再次设置 activeIndexActive
        }
      }
    },
    methods: {
      // 获取个人用户信息(存入vuex)
      async getpersoninfoall() {
        const {
          data
        } = await request({
          url: "/customer/PersonalUserInfo/getInfo",
          method: "POST",
          params: {
            personId: this.personInfoid,
          }
        })
        if (data.code == 200) {
          console.log(data.data)
          this.$store.commit("updatepersonInfo", data.data)
          // this.isSignIn = data.data.isSignIn
        }

      },
      async getorganinfo() {
        const {
          data
        } = await request({
          url: "/customer/OrgUserInfo/getInfo",
          method: "POST",
          params: {
            orgId: this.organInfoid,
          }
        })
        // 将数据存到vuex中
        this.$store.commit("updateorganInfo", data.data)
      },
      async getCanderDetail() {
        let userId = ''
        if (this.personInfoid) {
          userId = this.accountInfo.id
        } else if (this.organInfoid) {
          userId = this.organInfo.baseUserId
        }
        try {
          const {
            data
          } = await request({
            method: 'post',
            url: `/sign/list`,
            params: {
              userId: userId ? userId : '',
              month: this.selectedMonth + 1
            },
          })
          if (data.code == 200) {
            console.log(data.data)
            //  item.signDate去掉-用， 替换
            data.data.forEach(item => {
              item.dateArray = item.signDate.split("-");
              // 将月份和日期转换为不带前导零的数字（如果需要）
              item.formattedMonth = parseInt(item.dateArray[1], 10); // 2
              item.formattedDay = parseInt(item.dateArray[2], 10); // 9
              item.formattedDate = `${item.dateArray[0]}, ${item.formattedMonth}, ${item.formattedDay}`
            })
            //  将data.data中的signDate转化成signInDates的格式
            this.signInDates = data.data.map(item => new Date(item.formattedDate));
            //     this.signInDates = [
            //   new Date(2025, 1, 6),
            //   new Date(2025, 1, 7),
            //   new Date(2025, 1, 8),
            //   new Date(2025, 1, 9),
            // ];
          } else {
            this.$message({
              message: data.msg,
              type: 'warning',
            })
          }
        } catch (error) {
          this.$message({
            message: error,
            type: 'warning',
          })
        }
      },
      // 判断给定日期是否为今天
      isToday(date) {
        const today = new Date()
        return date.getDate() === today.getDate() &&
          date.getMonth() === today.getMonth() &&
          date.getFullYear() === today.getFullYear()
      },
      // 判断给定日期是否已签到
      isDateSigned(date) {
        return this.signInDates.some(signedDate => {
          const isSameDate =
            date.getDate() === signedDate.getDate() &&
            date.getMonth() === signedDate.getMonth() &&
            date.getFullYear() === signedDate.getFullYear();
          return isSameDate;
        });
      },
      // 获取签到积分（根据连续签到天数，最高5分）
      getSignInPoints(date) {
        if (!this.isDateSigned(date)) return 0

        // 找到当前日期在签到数组中的索引
        const index = this.signInDates.findIndex(signedDate =>
          signedDate.getDate() === date.getDate() &&
          signedDate.getMonth() === date.getMonth() &&
          signedDate.getFullYear() === date.getFullYear()
        )

        // 计算当前日期之前的连续签到天数
        let consecutiveDays = 1
        let prevDate = this.signInDates[index]

        // 向前查找连续签到的日期
        for (let i = index - 1; i >= 0; i--) {
          const currentDate = this.signInDates[i]
          const timeDiff = prevDate - currentDate
          const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24))

          if (daysDiff === 1) {
            consecutiveDays++
            prevDate = currentDate
          } else {
            break
          }
        }

        // 根据连续天数返回对应的积分（1-5分）
        return Math.min(consecutiveDays, 5)
      },
      // 获取指定索引位置的连续签到天数
      getConsecutiveDays(currentIndex) {
        let count = 1
        for (let i = currentIndex; i > 0; i--) {
          const diff = (this.signInDates[i] - this.signInDates[i - 1]) / (1000 * 60 * 60 * 24)
          if (diff !== 1) break
          count++
        }
        return count
      },
      // 点击日期进行签到
      signIn(day) {
        if (this.isToday(day.date) && !day.signed) {
          console.log(day)
          this.signMethod()
        }
        return
        // 如果已签到或不是今天，则不允许签到

        if (day.signed || !day.currentMonth) return

        // 不允许签到未来日期
        const today = new Date()
        console.log(day.date)
        console.log(today)
        if (day.date > today) return

        // 添加新的签到日期
        const newDate = new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate())
        this.signInDates.push(newDate)
        this.signInDates.sort((a, b) => a - b)

        // 更新连续签到天数
        const lastIndex = this.signInDates.length - 1
        let consecutiveDays = 1
        let prevDate = this.signInDates[lastIndex]

        // 向前查找连续签到的日期
        for (let i = lastIndex - 1; i >= 0; i--) {
          const currentDate = this.signInDates[i]
          const timeDiff = prevDate - currentDate
          const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24))

          if (daysDiff === 1) {
            consecutiveDays++
            prevDate = currentDate
          } else {
            break
          }
        }

        this.consecutiveDays = consecutiveDays
      },
      // 点击按钮签到今天
      signInToday() {
        const today = new Date()
        if (this.isTodaySigned) {
          // this.$message.success('您今日已签到')
          return
        }

        // // 添加今天的签到记录
        // const newDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        // this.signInDates.push(newDate)
        // this.signInDates.sort((a, b) => a - b)

        // // 更新连续签到天数
        // const lastIndex = this.signInDates.length - 1
        // let consecutiveDays = 1
        // let prevDate = this.signInDates[lastIndex]

        // // 向前查找连续签到的日期
        // for (let i = lastIndex - 1; i >= 0; i--) {
        //   const currentDate = this.signInDates[i]
        //   const timeDiff = prevDate - currentDate
        //   const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24))

        //   if (daysDiff === 1) {
        //     consecutiveDays++
        //     prevDate = currentDate
        //   } else {
        //     break
        //   }
        // }

        // this.consecutiveDays = consecutiveDays
        // 调用签到接口
        this.signMethod()

      },
      async signMethod() {
        let userId = ''
        if (this.personInfoid) {
          userId = this.accountInfo.id
        } else if (this.organInfoid) {
          userId = this.organInfo.baseUserId
        }
        try {
          const {
            data
          } = await request({
            method: 'post',
            url: `/sign/add`,
            params: {
              userId: userId ? userId : '',
            },
          })
          if (data.code == 200) {
            this.$message.success('签到成功！')
            if (this.personInfoid) {
              this.getpersoninfoall()
            } else if (this.organInfoid) {
              this.getorganinfo()
            }

            this.getCanderDetail()
          } else {
            this.$message({
              message: data.msg,
              type: 'warning',
            })
          }
        } catch (error) {
          this.$message({
            message: error,
            type: 'warning',
          })
        }
      },
      toSign() {
        this.getCanderDetail()
        this.dialogSignInVisible = true;
      },
      // 前往vip功能
      toVip() {
        // if (this.personInfo.isVip == 0) {
        //   return this.$message.warning('如果需要使用此功能请成为"认证会员"')
        // }
        this.$router.push({
          name: 'vipFunction'
        })
      },
      // 打开登录弹窗：若当前在注册路由，先跳回首页再弹窗，避免叠加在注册页上
      openLogin() {
        const path = this.$route.path || ''
        if (path.indexOf('/register') === 0) {
          this.$router.push({ path: '/' }).then(() => {
            this.dialogloginVisible = true
          })
        } else {
          this.dialogloginVisible = true
        }
      },
      // 是否拥有某权限
      hasPerm(perm) {
        return this.accountPermissions && this.accountPermissions.indexOf(perm) !== -1
      },
      // 前往成绩查询
      toScoreQuery() {
        this.$router.push({
          name: 'scoreQuery'
        })
      },
      // tab下拉事件
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
        this.mobileMenuOpen = false
        //  每次点击时  都存入index值  防止刷新后 默认为首页index
        this.$store.commit("updatetabIndexActive", key)
        //  key : router
        const indexObj = {
          "1": () => this.$router.push({
            name: "home"
          }),
          "2": () => this.$router.push({
            path: "/newsnotice"
          }), // 新闻公告（协会公告+新闻专区 统一入口）
          "3": () => this.$router.push({
            name: "move"
          }),
          "9": () => this.$router.push({
            name: "matchPublish"
          }),
          "11": () => this.$router.push({ path: "/events" }),
          "10": () => this.$router.push({ path: "/services" }),
          "12": () => this.$router.push({ path: "/fitness" }),
          // "8": () => this.$router.push({
          //   name: "activity"
          // }), // 活动中心入口已停用（迁移至体智能专区）
          // "4" 新闻专区入口已合并至"新闻公告"(index 2)
          // 组织机构/会员单位/关于协会 入口已停用（2026-09-02 前端隐藏，路由保留可直连）
          // "5": () => this.$router.push({
          //   name: "organ"
          // }),
          // "5-1": () => this.$router.push({
          //   name: "organ"
          // }),
          // "5-2": () => this.$router.push({
          //   name: "school"
          // }),
          // "6": () => this.$router.push({
          //   name: "about"
          // }),
          // "7": () => this.$router.push({
          //   name: "institution"
          // }),
        }
        if (indexObj[key]) {
          indexObj[key]()
        } else {
          console.log("执行错误")
        }

      },
      //签到
      personsign() {
        // 提示已签到
        this.$message({
          type: 'success',
          message: '签到成功'
        });
        // 发起请求 获取状态

        //将签到变为已经签到
        this.ispersonsign = true
      },
      // 审核中提示
      verifyinfo() {
        this.$message({
          type: 'warning',
          message: '机构信息审核中，请耐心等待'
        });
      },
      toinfo() {
        // 判断 类型是机构注册 还是个人注册
        if (this.accountInfotype == "1") {
          // 跳转个人信息页面
          this.$router.push({
            name: 'accountInfopersoninfor'
          })
        } else {
          // 跳转机构信息页面
          this.$router.push({
            name: 'organInfopersoninfor'
          })
        }
      },
      // 退出登录机构
      loginout() {
        this.$confirm('您确定要退出当前账号吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          confirmButtonClass: "el-button--success",
        }).then(async () => {
          // 更改为未登录状态
          // 将token 存入（清空）vuex
          await this.$store.commit("savetoken", false)
          // 清空vuex及本地存储的用户数据
          this.$store.commit("updateaccountInfo", {})
          this.$store.commit("updateorganInfo", {})
          this.$store.commit("updatepersonInfo", {})
          // 滚动到最顶部 再跳转到首页
          document.documentElement.scrollTop = 0
          // 跳转到首页
          this.$router.push({
            path: '/'
          })
          // 将 index索引值存入vuex
          this.$store.commit("updatetabIndexActive", "1")

          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        }).catch(() => {});
      },
      // 退出登录个人
      loginoutperson() {
        this.$confirm('您确定要退出当前账号吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          confirmButtonClass: "el-button--success",
        }).then(async () => {
          // 更改为未登录状态
          // 将token 存入（清空）vuex
          await this.$store.commit("savetoken", false)
          // 清空vuex及本地存储的用户数据
          this.$store.commit("updateaccountInfo", {})
          this.$store.commit("updatepersonInfo", {})

          // 滚动到最顶部 再跳转到首页 
          document.documentElement.scrollTop = 0
          // 跳转到首页
          this.$router.push({
            path: '/'
          })
          // 将 index索引值存入vuex
          this.$store.commit("updatetabIndexActive", "1")

          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        }).catch(() => {});
      },
      // 注册身份选择后 跳转对应注册路由页
      // 打开注册弹窗：重置为第一步（注册类型选择）
      openRegister() {
        this.registerStep = 'type'
        this.dialogregisterVisible = true
      },
      // 组织注册：按组织类型跳转对应注册页
      goOrganRegister(key) {
        this.dialogregisterVisible = false
        this.$router.push({ path: `/register/${key}` })
      },
      onRegisterIdentity(payload) {
        this.dialogregisterVisible = false
        this.$router.push({
          path: `/register/${payload.key}`
        })
      },
      // 下载资料
      downloadResource(r) {
        if (r.url) {
          window.open(r.url, '_blank')
        } else {
          this.$message.info('资料准备中，敬请期待')
        }
      },
      closelogin(val) {
        // 子传父 关闭登录弹层事件 并且更改显示状态
        this.dialogloginVisible = val

        // 手动更改显示状态
        this.login = true
      },
      closeauth(val) {
        // 子传父 个人认证关闭
        this.dialogauthVisible = val
      },
      closeorganauth(val) {
        // 子传父 机构认证关闭
        this.dialogauthVisible = val
      },
      // 点击logo 跳转首页
      toLinkHome() {
        this.$router.push({
          name: "home"
        })
      }
    }
  }

</script>


<style lang="less" scoped>
// .father{
//   padding-top: 20px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
nav {
  // height: 190px;
  // width: 100%; max-width: 1440px;

  // padding: 10px 0px;
  /* 导航栏背景色 */
  background-color: var(--ts-primary);
  display: flex;

  // justify-content: center;
  justify-content: center;
  align-items: center;
  // flex-wrap: wrap;
  // align-content:flex-start;
}

// 宽度设置盒子
.widthSet {
  padding-top: 10px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
}

/* 平板区间（769px ~ 1024px）：桌面布局的紧凑过渡 */
@media (min-width: 769px) and (max-width: 1024px) {
  .widthSet {
    padding-left: 10px;
    padding-right: 10px;
  }

  .info {
    margin: 12px 0 10px;
  }

  .info p:first-child {
    font-size: 18px;
    letter-spacing: 2px;
  }

  .info p:last-child {
    font-size: 12px;
  }

  .logo {
    width: 56px;
  }

  .infotext {
    margin-left: 8px;
    min-width: 0;
  }

  /* 未登录按钮收紧（保持 44px 触控高度，仅压缩内边距/字号） */
  .nonelogin {
    width: auto;
    padding-bottom: 2px;
  }

  .nonelogin button {
    width: auto;
    height: 44px;
    font-size: 14px;
    padding: 0 12px;
    margin-right: 8px;
  }

  /* 登录后信息行收紧 */
  .loginok {
    font-size: 14px;
    min-width: 0;
    margin-bottom: 4px;
  }

  .loginok .rightAlign-item {
    padding-bottom: 4px;
    min-width: 0;
  }

  .vip-badge {
    height: 20px;
    font-size: 12px;
    line-height: 20px;
    padding: 0 8px 0 2px;
    margin-left: 6px;
  }

  .vip-badge .vip-badge-v {
    width: 15px;
    height: 15px;
    font-size: 10px;
    line-height: 15px;
  }

  .clicki {
    min-width: 0;
    padding-left: 0;
  }

  .clicki button {
    height: 44px;
    font-size: 13px;
    width: auto;
    padding: 0 12px;
    margin-right: 6px;
    white-space: nowrap;
  }

  /* 横向菜单项间距压缩，保证 7 项在 769px 宽也能单行放下 */
  /deep/ .el-menu-item {
    font-size: 15px;
    padding: 0 14px;
    height: 52px !important;
    line-height: 52px !important;
  }
}

// 左侧盒子(图标信息)
.leftInfo {
  display: flex;
  align-items: center;
}

// 右侧盒子（tab + 按钮）
// .rightInfo{
//   // display: flex;
//   // align-items: center;
//   // justify-content: space-between;
// }
// ↑↑ 右侧盒子（tab + 按钮）

/* 未登录盒子 */
.nonelogin {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 300px;
  padding-bottom: 5px;
}

.nonelogin button {
  background-color: #ffffff;
  color: var(--ts-primary);
  width: auto;
  min-width: 44px;
  height: 44px;
  font-size: 15px;
  padding: 0 16px;
  text-align: center;
  margin-right: 10px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 6px;
  box-sizing: border-box;
  transition: background-color 0.25s ease, color 0.25s ease;
}

.nonelogin button:hover {
  background-color: var(--ts-active);
  color: var(--ts-on-primary);
}

.nonelogin button:last-child {
  margin-right: 0;
}

/* ------------------------------ */
/* 登录盒子 */
.rightAlign {
  // text-align: right;
  padding-right: 15px;
  padding-left: 15px;

  .rightAlign-item {
    display: flex;
    align-items: center;

    padding-bottom: 10px;

    // 会员标识徽章（金黄主色）：is-vip=会员 / not-vip=非会员
    .vip-badge {
      display: inline-flex;
      align-items: center;
      margin-left: 8px;
      padding: 2px 10px 2px 3px;
      height: 24px;
      border-radius: 12px;
      font-size: 14px;
      line-height: 24px;
      vertical-align: middle;

      .vip-badge-v {
        font-style: normal;
        width: 18px;
        height: 18px;
        margin-right: 4px;
        border-radius: 50%;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        line-height: 18px;
        flex-shrink: 0;
      }

      &.is-vip {
        color: #8a5a00;
        background: linear-gradient(135deg, #ffe9b3 0%, #ffd25e 100%);
        border: 1px solid #e6b84a;

        .vip-badge-v {
          color: #fff;
          background: linear-gradient(135deg, #f5b219 0%, #d99412 100%);
          text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
        }
      }

      &.not-vip {
        color: #7a7a7a;
        background: #f2f3f5;
        border: 1px solid #dcdfe6;

        .vip-badge-v {
          color: #fff;
          background: #b8bcc4;
        }
      }
    }

    .viplogoBox {
      .viplogo {
        width: 0.55rem;
        height: 0.55rem;
        margin-left: 0.4rem;
        z-index: 999;
      }

      display: flex;
      font-size: 0.22rem;
      align-items: center;

      .text {
        padding: 0.01rem 0.2rem;
        margin-left: -0.2rem;
        background-color: rgba(210, 162, 95, 0.7);
      }

      .notext {
        padding: 0.01rem 0.2rem;
        margin-left: -0.2rem;
        font-size: 0.2rem;
        background-color: rgba(203, 201, 204, 0.7);
      }
    }
  }
}

.loginok {
  min-width: 240px;
  display: flex;
  flex-direction: column;
  // min-width: 144px;  //待确认设置最小宽度是否可行  可能会造成部分用户电脑出现滚动条
  align-content: center;
  // justify-content: flex-start;
  // padding-bottom: 10px;
  // margin-right: 260px;
}

.loginok {
  letter-spacing: 0px !important;
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 10px;
}

/* 按钮+图标 */
.clicki {
  min-width: 210px;
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clicki button {
  background-color: #ffffff;
  color: var(--ts-primary);
  height: 44px;
  min-width: 44px;
  font-size: 15px;
  padding: 0 16px;
  text-align: center;
  width: auto;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 6px;
  margin: 0 10px 0 0;
  box-sizing: border-box;
  transition: background-color 0.25s ease, color 0.25s ease;
}

.clicki button:hover {
  background-color: var(--ts-active);
  color: var(--ts-on-primary);
}

/* 资料下载入口按钮：与普通按钮同高 44px、同圆角，图标+文字自适应宽度 */
.nonelogin .dl-entry,
.clicki .dl-entry {
  background-color: #ffffff;
  color: var(--ts-primary);
  width: auto;
  min-width: 44px;
  height: 44px;
  font-size: 15px;
  padding: 0 16px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 6px;
  margin-right: 10px;
  box-sizing: border-box;
  transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;
}

.nonelogin .dl-entry:hover,
.clicki .dl-entry:hover {
  background-color: var(--ts-primary-hover);
  color: #ffffff;
  border-color: var(--ts-primary-hover);
}

.dl-entry i {
  margin-right: 4px;
}

/* 资料下载弹窗列表 */
.download-dialog-list {
  .download-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    margin-bottom: 10px;
    border: 1px solid var(--ts-border);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;

    .download-item-name {
      flex: 1;
      margin-left: 10px;
      font-size: 16px;
      color: var(--ts-text);
    }

    .download-item-icon {
      color: var(--ts-primary);
      font-size: 18px;
    }
  }

  .download-item:hover {
    background-color: #f5f8ff;
    border-color: var(--ts-primary);
  }

  .download-item:last-child {
    margin-bottom: 0;
  }
}

.clicki img {
  color: var(--ts-primary);
  width: 26px;
  height: 26px;
}

.btninfo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btninfo button {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 33px;
  line-height: 33px;
}

.btninfo button p {
  margin-bottom: 0px;
  font-size: 17px;
}

/* ------------------------------ */

/* ------------------------------ */

// 顶部tab
/* 路由盒子 */
.tag {
  width: 900px;
  display: flex;
  padding: 0px 20px;
  justify-content: space-between;
  // justify-content: space-around;
  // min-width: 570px;//待确认设置最小宽度是否可行  可能会造成部分用户电脑出现滚动条
  // min-width: 830px;//待确认设置最小宽度是否可行  可能会造成部分用户电脑出现滚动条
  // height: 50px;
  // line-height: 50px;
  // flex: auto;
  // margin-left: 120px;
  // margin-right: 50px;
}

nav a {
  color: #ffffff;
  font-size: 18px;
  margin-right: 27px;
  padding-bottom: 15px;
}

nav a:last-child {
  margin-right: 0px;
}

nav a.router-link-exact-active {
  color: var(--ts-active);
  border-bottom: 6px solid var(--ts-active);
}

/* ------------------------------------- */
// 弹窗
/deep/ .el-dialog {
  width: 600px;
  // height: 580px !important; 不定义高度 让其随内容自适应
  border-radius: 10px;
  // box-shadow :5px 5px   rgb(1,1,1, 0.01);
  padding: 0px 60px 40px;
}

// /deep/ .el-dialog__header {
//   background-color: #0099ff;

//   font-weight: 600;
// }

// /deep/ .el-dialog__title {
//   color: #fff !important;
//   font-size: 1.3rem;
// }

// /deep/ .el-dialog__headerbtn .el-dialog__close {
//   color: #fff !important;
//   font-size: 1.6rem;
// }
// /deep/ .el-dialog__body {
//   padding: 1rem 5rem;
// }
.authlogo {
  padding-top: 0px;
}

.authlogo img {
  width: 18px;
  margin-top: -2px;
}

/* 第一行 */
.info {
  margin: 20px 0px 15px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  // padding-right: 25px;
}

.infotext {
  text-align: left;
  // width: 350px;
  margin-left: 10px;
}

.info p:first-child {
  font-size: 22px;
  letter-spacing: 4px;
}

.info p:last-child {
  font-size: 18px;
}

//顶部
.logo {
  width: 80px;
  // height: 99px;
}

.logo img {
  width: 100%;
  height: 100%;
}

// 第二行  下方tab
.tabSelect {
  width: 100%;
  text-align: center;
}

/* PC 端菜单均匀撑满：el-menu 占满整行，菜单项等宽分布 */
/deep/ .el-menu.el-menu--horizontal {
  display: flex;
  width: 100%;
}

/deep/ .el-menu-item {
  font-size: 18px;
  height: 60px !important;
  line-height: 60px !important;
  flex: 1;
  padding: 0 !important;
  text-align: center;
}

/deep/ .el-menu-item:last-child {
  padding: 0 !important;
}

/deep/.el-submenu__title {
  font-size: 18px;
  height: 60px !important;
  line-height: 60px !important;
  padding: 0px 50px;
}

// 整个tab的样式
// .el-menu--horizontal{
//   position: absolute;
//   top: 189px;
//   left: 803px;
//   z-index: 2050;
// }
.el-menu--popup-bottom-start {
  min-width: 100px !important;
}

.el-menu--horizontal .el-menu .el-menu-item {
  display: flex;
  justify-content: center;
  padding: none;
  font-size: 16px;
}

/deep/.el-submenu__icon-arrow {
  font-size: 20px;
  color: #ffffff;
}

.calendar-dialog {
  // 弹窗
  /deep/ .el-dialog {
    // width: 600px !important;
    width: 4rem;
    // height: 580px !important; 不定义高度 让其随内容自适应
    border-radius: 10px;
    // box-shadow :5px 5px   rgb(1,1,1, 0.01);
    padding: 0;
  }

  /deep/ .el-dialog__header {
    background-color: #0099ff;

    font-weight: 600;
  }

  /deep/ .el-dialog__title {
    color: #fff !important;
    font-size: 1.3rem;
  }

  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
    font-size: 1.6rem;
  }

  /deep/ .el-dialog__body {
    padding: 1rem 5rem;
  }

  // background-color: #3498db; // 设置弹窗背景色为蓝色
  .sign-in-calendar {
    // max-width: 800px;
    margin: 1rem auto 2.5rem;
    padding: 1.5rem;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      sans-serif;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
  }

  .calendar-header {
    text-align: center;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .calendar-header h1 {
    font-size: 1.6rem;
    color: #2c3e50;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }

  .month-display {
    position: absolute;
    font-size: 1.1rem;
    color: #7f8c8d;
    margin: 0.5rem 0;
    font-weight: 400;
    // float: right;
    right: 0;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 1.5rem;
    background-color: #fcfcfc;
    border-radius: 12px;
    padding: 12px;
  }

  .weekday-header {
    background-color: transparent;
    color: #7f8c8d;
    padding: 8px;
    text-align: center;
    font-weight: 500;
    font-size: 0.85rem;
  }

  .calendar-day {
    background-color: #fff;
    padding: 8px;
    min-height: 4.5rem;
    position: relative;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.15s ease;
    border: 1px solid #ccc;
    overflow: visible;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    margin: 0;
    width: 100%;
  }

  .calendar-day.signed {
    background-color: #f8fafd;
    border: 1px solid #edf2f7;
    color: #3498db;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    padding: 8px;
  }

  .calendar-day:not(.current-month) {
    opacity: 0.5;
    background-color: #f8f9fa;
    cursor: default;
  }

  .calendar-day:not(.current-month) .day-number {
    color: #adb5bd;
  }

  .calendar-day:not(.current-month).signed {
    background-color: #f8f9fa;
    border-color: #e9ecef;
  }

  .calendar-day:not(.current-month) .points {
    background-color: #adb5bd;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    background-color: #fcfcfc;
    border-radius: 12px;
    padding: 12px;
    width: 100%;
  }

  .day-number {
    // position: absolute;
    // top: 4px;
    // left: 4px;
    font-size: 1rem;
    font-weight: 400;
    color: #34495e;
  }

  .today-day-number-nosign {
    color: #fff;
  }

  .signed {
    background-color: #f8fafd;
    border: 1px solid #edf2f7;
    border-radius: 8px;
    color: #3498db;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    margin: 0 10px;
    padding: 6px 12px;
    transition: all 0.2s ease;
  }

  .date-select {
    padding: 4px 8px;
    font-size: 0.9rem;
    border: 1px solid #e0e0e0;
    background-color: white;
    color: #7f8c8d;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 4px;
    transition: all 0.15s ease;
    outline: none;
  }

  .date-select:hover {
    border-color: #3498db;
  }

  .date-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
  }

  .circle-out {
    position: absolute;
    bottom: 2px;
    left: 1.5rem;
  }

  .circle {
    background-color: #009a33;
    color: white;
    padding: 0.18rem 0.65rem;
    border-radius: 50%;
    font-size: 1rem;
    font-weight: 400;
    text-align: center;
  }

  .points {
    color: #009a33;
  }

  // .points {
  //   position: absolute;
  //   bottom: 2px;
  //   right: 2px;
  //   background-color: #009a33;
  //   color: white;
  //   padding: 0px 2px;
  //   border-radius: 4px;
  //   font-size: 0.6rem;
  //   font-weight: 400;
  //   min-width: 16px;
  //   text-align: center;
  // }

  .today {
    // border: 1px solid #3498db;
    background-color: #fe9900;
    color: #fff;
  }

  .today-signed {
    border: 1px solid #fe9900;
    // background-color: #fe9900;
    // color: #fff;
  }

  // .today::after {
  //   content: '今';
  //   position: absolute;
  //   top: -2px;
  //   right: -2px;
  //   background-color: #3498db;
  //   color: white;
  //   padding: 0.2rem;
  //   border-radius: 4px;
  //   font-size: 0.6rem;
  //   font-weight: 400;
  //   line-height: 1;
  // }

  .sign-in-button-container {
    text-align: center;
    margin-top: 2rem;
  }

  .sign-in-button {
    padding: 0.4rem 1.5rem;
    font-size: 0.8rem;
    border: none;
    border-radius: 30px;
    background-color: #3498db;
    color: white;
    cursor: pointer;
    transition: all 0.15s ease;
    font-weight: 500;
    letter-spacing: 0.5px;
  }

  .sign-in-button:hover:not(.signed) {
    background-color: #2980b9;
    transform: translateY(-1px);
  }

  .sign-in-button.signed {
    background-color: #009a33;
    color: #fff;
    cursor: not-allowed;
  }
}

/* ============ 移动端导航 ============ */
/* 桌面端：完全隐藏，不参与布局与定位 */
.mobile-menu-toggle {
  display: none;
}
.mobile-nav {
  display: none;
}

@media (max-width: 768px) {
  /* 顶部栏：左 logo+标题，右 登录/注册按钮 + 汉堡，整体垂直居中 */
  .info {
    position: relative;
    margin: 10px 0 10px;
    padding-right: 4px;
    flex-wrap: nowrap;
    align-items: center;
  }

  /* 汉堡按钮：绝对定位固定在顶栏右上角（与 logo 首行对齐），不随登录区换行 */
  .mobile-menu-toggle {
    position: absolute;
    top: 8px;
    right: 0;
    margin-left: 0;
    z-index: 60;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 8px;
    color: #fff;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.35);
  }

  .logo {
    width: 48px;
    flex-shrink: 0;
  }

  .infotext {
    margin-left: 8px;
    min-width: 0;
  }

  .info p:first-child {
    font-size: 16px;
    letter-spacing: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .info p:last-child {
    font-size: 11px;
    letter-spacing: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* 未登录按钮：紧凑，与汉堡同排右对齐 */
  .nonelogin {
    width: auto;
    flex-shrink: 0;
    justify-content: flex-end;
    padding-bottom: 0;
  }

  .nonelogin .dl-entry {
    display: none;
  }

  .nonelogin button {
    width: auto;
    height: 26px;
    padding: 0 7px;
    font-size: 12px;
    margin-right: 6px;
    white-space: nowrap;
  }

  /* 隐藏桌面横向菜单，显示移动折叠菜单 */
  .tabSelect {
    display: none;
  }

  .mobile-nav {
    display: block;
    background: rgba(30, 64, 175, 0.98);
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding: 6px 0 10px;
  }

  .mobile-nav-item {
    padding: 13px 18px;
    color: #fff;
    font-size: 16px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .mobile-nav-item.active {
    color: #93c5fd;
    font-weight: 600;
  }

  /* 登录状态：简化，隐藏冗余会员文字，只保留欢迎简语 + 关键按钮 */
  .loginok {
    font-size: 13px;
    min-width: 0;
    margin-bottom: 0;
    max-width: 100%;
  }
  .loginok .rightAlign {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }
  .loginok .rightAlign-item {
    padding-bottom: 0;
    display: flex;
    align-items: center;
    min-width: 0;
  }
  .loginok .rightAlign-item span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 88px;
    flex-shrink: 1;
  }
  /* 移动端会员徽章：紧凑尺寸，不换行不溢出（补全选择器链，优先级需 ≥ 桌面端 .rightAlign .rightAlign-item .vip-badge） */
  .loginok .rightAlign-item .vip-badge {
    height: 18px;
    font-size: 11px;
    line-height: 18px;
    padding: 0 6px 0 2px;
    margin-left: 5px;
    flex-shrink: 0;
    white-space: nowrap;
  }
  .loginok .rightAlign-item .vip-badge .vip-badge-v {
    width: 14px;
    height: 14px;
    font-size: 10px;
    line-height: 14px;
    margin-right: 3px;
  }
  .loginok .rightAlign-item .viplogoBox {
    display: none;
  }
  .loginok div[style*="margin-bottom"] {
    margin-bottom: 0 !important;
  }

  .clicki {
    min-width: 0;
    padding-left: 0;
    max-width: 100%;
  }
  .clicki button {
    height: 28px;
    font-size: 12px;
    padding: 0 8px;
    margin-left: 0;
    margin-right: 6px;
    width: auto;
    white-space: nowrap;
  }
  .clicki div {
    display: flex;
    flex-wrap: wrap;
    row-gap: 4px;
    max-width: 100%;
  }

  /* ===== 登录态统一适配（768px 以下）：
     .info 允许换行，登录区独占第二行：欢迎行 + 按钮横向排列，44px 触控高度 ===== */
  .info {
    flex-wrap: wrap;
  }

  .rightInfo.is-login {
    flex: 1 1 100%;
    min-width: 0;
    margin-top: 2px;
    margin-bottom: 4px;
  }

  .rightInfo.is-login .loginok {
    width: 100%;
  }

  .rightInfo.is-login .rightAlign {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: visible;
  }

  .rightInfo.is-login .rightAlign-item {
    padding-bottom: 2px;
    min-width: 0;
  }

  /* 欢迎行姓名放宽到 120px，徽章保持紧凑 */
  .rightInfo.is-login .rightAlign-item > span:first-child {
    max-width: 120px;
  }

  /* 功能按钮：紧凑尺寸、靠左排列（覆盖桌面端 justify-content: center） */
  .rightInfo.is-login .clicki {
    width: 100%;
    padding-left: 0;
    margin-top: 8px;
    justify-content: flex-start;
  }

  .rightInfo.is-login .clicki div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 100%;
  }

  .rightInfo.is-login .clicki button {
    flex: 0 0 auto;
    min-width: 0;
    height: 32px;
    font-size: 12px;
    padding: 0 12px;
    margin: 0;
    border-radius: 6px;
    white-space: nowrap;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  /* 资料下载按钮（含图标）与普通按钮完全同尺寸，图标字号统一 */
  .rightInfo.is-login .clicki .dl-entry {
    width: auto;
    height: 44px;
    font-size: 13px;
    padding: 0 14px;
    margin: 0;
    border-radius: 6px;
  }

  .rightInfo.is-login .clicki button i {
    font-size: 14px;
    margin-right: 4px;
  }

  /* 未登录态按钮：紧凑小按钮，不遮挡标题 */
  .nonelogin button {
    height: 30px;
    min-width: 0;
    line-height: 30px;
    font-size: 12px;
    padding: 0 10px;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .nonelogin button i {
    margin-right: 2px;
  }
}
</style>

<!-- 身份选择弹窗：去掉外层白色边框/内边距，让渐变背景铺满 -->
<style lang="less">
  .identity-dialog.el-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(30, 58, 138, 0.18);
  }
  .identity-dialog .el-dialog__body {
    padding: 0 !important;
  }
  /* 关闭按钮：加大加明显（白圆底 + 深色图标 + 投影） */
  .identity-dialog .el-dialog__headerbtn {
    width: 34px;
    height: 34px;
    top: 12px;
    right: 12px;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(30, 58, 138, 0.28);
    z-index: 2;
  }
  .identity-dialog .el-dialog__headerbtn .el-dialog__close {
    font-size: 20px;
    line-height: 34px;
    color: #1e3a8a;
  }
  .identity-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: var(--ts-primary, #1e40af);
  }
  /* 注册类型选择（个人/组织）：复用身份选择视觉风格 */
  .register-type-select {
    width: 100%;
    padding: 22px 26px 30px;
    background: linear-gradient(160deg, #eaf2ff 0%, #f6faff 45%, #fff7ec 100%);
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    text-align: center;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 6px;
      background: linear-gradient(90deg, #1e40af, #3b82f6 40%, #ff8f00 100%);
    }
  }
  .register-type-select .rts-title {
    font-size: 24px;
    font-weight: 800;
    color: #1e3a8a;
    letter-spacing: 1px;
  }
  .register-type-select .rts-subtitle {
    margin-top: 8px;
    font-size: 13px;
    color: #64748b;
  }
  .register-type-select .rts-cards {
    margin-top: 26px;
    display: flex;
    justify-content: center;
    gap: 22px;
    flex-wrap: nowrap;
  }
  .register-type-select .rts-card {
    flex: 1;
    max-width: 240px;
    padding: 30px 18px 26px;
    background: #ffffff;
    border: 1.5px solid #dbe4f2;
    border-radius: 18px;
    cursor: pointer;
    user-select: none;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 14px rgba(30, 58, 138, 0.06);
  }
  .register-type-select .rts-card:hover {
    transform: translateY(-7px);
    border-color: transparent;
  }
  .register-type-select .rts-card .rts-icon {
    width: 74px;
    height: 74px;
    margin: 0 auto 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 22px;
    font-size: 34px;
    color: #ffffff;
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.14);
  }
  .register-type-select .rts-card.personal .rts-icon {
    background: linear-gradient(135deg, #1e40af, #3b82f6);
  }
  .register-type-select .rts-card.personal:hover {
    box-shadow: 0 18px 36px rgba(59, 130, 246, 0.24);
    border-color: #3b82f6;
  }
  .register-type-select .rts-card.organ .rts-icon {
    background: linear-gradient(135deg, #f97316, #fb923c);
  }
  .register-type-select .rts-card.organ:hover {
    box-shadow: 0 18px 36px rgba(249, 115, 22, 0.24);
    border-color: #fb923c;
  }
  /* 组织类型三卡片：学校（蓝）/ 俱乐部（绿）/ 协会单位（橙） */
  .register-type-select .rts-card.org-school .rts-icon {
    background: linear-gradient(135deg, #1e40af, #3b82f6);
  }
  .register-type-select .rts-card.org-school:hover {
    box-shadow: 0 18px 36px rgba(59, 130, 246, 0.24);
    border-color: #3b82f6;
  }
  .register-type-select .rts-card.org-club .rts-icon {
    background: linear-gradient(135deg, #15803d, #22c55e);
  }
  .register-type-select .rts-card.org-club:hover {
    box-shadow: 0 18px 36px rgba(34, 197, 94, 0.24);
    border-color: #22c55e;
  }
  .register-type-select .rts-card.org-assoc .rts-icon {
    background: linear-gradient(135deg, #f97316, #fb923c);
  }
  .register-type-select .rts-card.org-assoc:hover {
    box-shadow: 0 18px 36px rgba(249, 115, 22, 0.24);
    border-color: #fb923c;
  }
  .register-type-select .rts-back {
    margin-top: 18px;
    font-size: 14px;
    color: #64748b;
    cursor: pointer;

    i {
      margin-right: 4px;
    }

    &:hover {
      color: var(--ts-primary, #1e40af);
    }
  }
  .register-type-select .rts-card .rts-name {
    font-size: 21px;
    font-weight: 800;
    color: #1f2937;
  }
  .register-type-select .rts-card .rts-desc {
    margin-top: 8px;
    font-size: 12.5px;
    color: #64748b;
  }
  @media (max-width: 768px) {
    .register-type-select {
      padding: 18px 16px 22px;
    }
    .register-type-select .rts-title {
      font-size: 19px;
      letter-spacing: 0.5px;
    }
    .register-type-select .rts-subtitle {
      margin-top: 6px;
      font-size: 12.5px;
    }
    .register-type-select .rts-cards {
      flex-direction: column;
      gap: 12px;
      margin-top: 18px;
    }
    .register-type-select .rts-card {
      display: flex;
      align-items: center;
      max-width: 100%;
      padding: 14px 16px;
      border-radius: 14px;
      text-align: left;
    }
    .register-type-select .rts-card:hover {
      transform: none;
    }
    .register-type-select .rts-card .rts-icon {
      width: 52px;
      height: 52px;
      margin: 0 14px 0 0;
      border-radius: 14px;
      font-size: 24px;
      flex-shrink: 0;
    }
    .register-type-select .rts-card .rts-name {
      font-size: 17px;
    }
    .register-type-select .rts-card .rts-desc {
      margin-top: 4px;
      font-size: 12px;
    }
  }
  /* 移动端：登录/注册身份弹窗自适应宽度 */
  @media (max-width: 768px) {
    .identity-dialog.el-dialog,
    .el-dialog {
      width: 92vw !important;
      max-width: 760px;
    }
    /* 去掉桌面端弹窗左右 60px 内边距（/deep/ .el-dialog 的 padding），手机上内容铺满 */
    .el-dialog {
      padding: 0 0 12px !important;
    }
    .el-dialog__body {
      padding: 0 !important;
    }
  }

  /* 平板：弹窗不超过视口 */
  @media (min-width: 769px) and (max-width: 1024px) {
    .identity-dialog.el-dialog,
    .el-dialog {
      width: 88vw !important;
      max-width: 760px;
    }
  }
</style>











